'use strict';

var dateUtils = require('./dateUtils');

function dateToUserFormat(argDate) {
    if (argDate) {
        return dateUtils.format2user(argDate);
    } else {
        return argDate;
    }
}

function dateToServerFormat(argDate) {
    if (argDate) {
        return dateUtils.format2server(argDate);
    } else {
        return argDate;
    }
}

function booleanToFrontEnd(boolean) {
    if (boolean !== null) {
        return (boolean) ? 'YES' : 'NO';
    } else {
        return boolean;
    }
}

function frontEndToBoolean(yesNo) {
    if (yesNo !== null) {
        return (yesNo === 'YES');
    }
}

module.exports.dateToUserFormat = dateToUserFormat;
module.exports.dateToServerFormat = dateToServerFormat;
module.exports.booleanToFrontEnd = booleanToFrontEnd;
module.exports.frontEndToBoolean = frontEndToBoolean;


//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/modules/utils/converter.js
// module id = B67l
// module chunks = 0 1 2 3 4